import React from "react";
import { useNavigate, useParams } from "react-router";
import { db } from "../../../../dexie/db";
import Default from "../../../layouts/DefaultCrew";
import Template from "../../../templates/Crew/Arrival/ReportDetail";
import { LocationState } from "./Create/types";
import { useLiveQuery } from "dexie-react-hooks";
import { pageData } from "../../../../App";
import { mapToArrivalFormData, useArrivalForm } from "./arrival.module";
import { useGetLastFrontReport } from "../../../../hooks/dexie/dexie";

const ReportDetail = (props: LocationState): React.ReactElement => {
  const { reportId } = useParams<"reportId">();
  const report_id = Number(reportId);
  const navigate = useNavigate();

  const onBack = () => {
    navigate(pageData.crewArrival.path());
  };

  const deleteReport = () => {
    db.arrival.delete(report_id).catch((e) => console.error(e));
    navigate(pageData.crewArrival.path());
  };

  const arrival = useLiveQuery(() => db.arrival.get(report_id));

  const form = useArrivalForm([
    props.form,
    mapToArrivalFormData(arrival?.data),
  ]);

  const previousReport = useGetLastFrontReport();

  return (
    <Default title="" selectedTitle={"Arrival"}>
      <Template
        form={form.data}
        reportId={report_id}
        deleteReport={deleteReport}
        onBack={onBack}
        previousReport={previousReport}
        isSend={arrival?.isSend !== undefined ? arrival?.isSend : true}
      />
    </Default>
  );
};

export default ReportDetail;
